import Vehicle from '../components/views/vehicles/Vehicles.vue'
import VehicleCreate from '../components/views/vehicles/VehicleCreate.vue'
import VehicleDetail from '../components/views/vehicles/VehicleDetail.vue'

const routes = [{
        path: 'vehicle',
        component: Vehicle,
        name: 'Vehicle',
        meta: {
            description: 'List of Think Gas Vehicles',
            title: 'Vehicles',
            requiresAuth: true
        }
    },

    {
        path: 'vehicle/create',
        component: VehicleCreate,
        name: 'VehicleCreate',
        meta: {
            description: 'Add a new vehicle',
            title: 'Add Vehicles',
            requiresAuth: true
        }
    },
    {
        path: '/vehicle/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: '' }) : next()
        },
        component: VehicleDetail,
        name: 'VehicleDetail',
        meta: {
            description: 'Details for the selected vehicle',
            title: 'Update Vehicle',
            requiresAuth: true
        }
    },
]


export default routes


// WEBPACK FOOTER //
// ./src/routes/vehicles.route.js